const Role = { USER: 'user', BOT: 'bot' } as const;

export const mapConversationLogMessages = (conversationLog: unknown[]): unknown[] => {
    if (!Array.isArray(conversationLog)) return [];
    return conversationLog.map((msg: any, index: number, array: any[]) => {
        if (msg.role !== Role.BOT) return msg;
        try {
            const parsedMessage = msg.message;
            if (parsedMessage?.predictions?.length > 0) {
                return {
                    ...msg,
                    message: parsedMessage.predictions[0].answer,
                    metaData: parsedMessage.predictions[0].meta,
                    intent_and_entities: parsedMessage?.intent_and_entities,
                    thinkingProcesses: Array.isArray(msg.metadata?.advisor_events) ? msg.metadata.advisor_events : [],
                    explainanswer: {
                        answer: parsedMessage?.predictions?.[0]?.answer,
                        rephrased_query: parsedMessage?.predictions?.[0]?.meta[5]?.rephrased_query,
                        retrieved_context: parsedMessage?.predictions?.[0]?.retrived_context?.source_ids,
                        reranked_context: parsedMessage?.predictions[0].meta[1]?.source_ids,
                        metaData: parsedMessage?.predictions[0]?.meta?.[3]?.metadata ?? [],
                        question: array[index - 1]?.message,
                    },
                };
            }
        } catch {
            return msg;
        }
        return msg;
    });
};
